module.exports = __webpack_public_path__ + "img/memberReport_total.0102217f.svg";